import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { EnumUserRole } from 'lib/graphql';
import { BaseModule } from 'lib/modules';

// Lazy-loaded page component
const ProcessorChatPage = lazy(() =>
  import(/* webpackChunkName: "processor-chat" */ 'pages/processor/chat').then(
    (m) => ({ default: m.default }),
  ),
);

/**
 * Chat Module Implementation
 */
class ChatModuleClass extends BaseModule {
  id = 'CHAT';
  name = 'Chat';
  label = 'Processor Chat';
  description = 'Processor-customer communication and chat interface';
  version = '1.0.0';
  /**
   * Creates route objects for the Chat module
   * @param ProtectedRoute
   * @param LazyWrapper
   * @param settings
   * @param ModuleProtectedRoute
   */
  createRoutes = (
    ProtectedRoute: any,
    LazyWrapper: any,
    settings?: any,
    ModuleProtectedRoute?: any,
  ): RouteObject[] => {
    const routes: RouteObject[] = [];
    const RouteProtector = ModuleProtectedRoute || ProtectedRoute;

    // Processor chat
    routes.push({
      path: '/processor/chat',
      element: (
        <RouteProtector
          component={ProcessorChatPage}
          moduleId="CHAT"
          allowedUserRoles={[EnumUserRole.Vendor]}
        />
      ),
    });

    return routes;
  };
}

// Export singleton instance
export const ChatModule = new ChatModuleClass();
